import React from 'react'
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import Tooltip from '@mui/material/Tooltip';
const Imagelist = ({ images, onDeleteImage }) => {

    return (
        <Box sx={{ width: 200, height: 200, overflowY: 'scroll' }}>
            <ImageList cols={3} rowHeight={121} gap={8}>
                {images && images.map((item) => (
                    <ImageListItem key={item.url} sx={{
                        position: "relative",
                        "&:hover .delete-icon": {
                            opacity: 1,
                        },
                        
                    }}>
                        <img
                            srcSet={`${item.url}`}
                            src={`${item.url}`}
                            alt={item.url}
                            loading="lazy"
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                borderRadius: 4,
                            }}
                        />

                        <Tooltip title="Delete">
                            <IconButton
                                className="delete-icon"
                                size="small"
                                sx={{
                                    position: "absolute",
                                    top: 4,
                                    right: 4,
                                    backgroundColor: "rgba(0,0,0,0.6)",
                                    color: "#fff",
                                    opacity: 0,
                                    transition: "opacity 0.2s ease",
                                    "&:hover": {
                                        backgroundColor: "rgba(0,0,0,0.8)",
                                    },
                                }}
                                onClick={(e) => {
                                    e.stopPropagation();  // ✅ Stops ImageListItem click
                                    e.preventDefault();
                                    onDeleteImage(item)
                                }}

                            >
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </ImageListItem>
                ))}
            </ImageList>
        </Box>
    )
}

export default Imagelist